import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Accessrequest } from '../accessrequest/accessrequest';

@Injectable({
  providedIn: 'root'
})
export class AdminAccessrightService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Accessrequest[]> {
    return this.httpClient.get<Accessrequest[]>(this.baseUrl + 'api/userapi/GetAllrequests')
  }
 
  Put(accessrequest: Accessrequest): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/userapi/Updateuserrights', accessrequest, { headers: header, observe: 'response' })
  }


}
